import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ConstantService, SessionStorage } from './services/constant.service';
import { EncryptionService } from './services/encryption.service';
import { TokenService } from './services/token.service';
import { UserSessionService } from './services/user-session.service';
import { SessionStorageService } from './services/session-storage.service';
import { JWTTokenReq } from './models/request.model';
import { UtilService } from './services/util.service';
import clevertap from 'clevertap-web-sdk';


@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.less'
})
export class AppComponent {

  constructor(private constantService: ConstantService, private encryptionService : EncryptionService,private tokenService : TokenService,private userSessionService : UserSessionService, private sessionStorageService :SessionStorageService, private utilService : UtilService){}
   
  ngOnInit():void{
      this.JWTToken();
      clevertap.init('R74-5R4-6W5Z');
      clevertap.onUserLogin.push({
          Site: {
              Name: sessionStorage.getItem('userName') || '',
              Identity: sessionStorage.getItem('clientCode') || ''
          }
      });
    }

  setCookies(){
    try {
        (window as any).segment_modification_func = (data: string) => {
          const result: string[] = data.split(',');
          
          document.cookie = `${result[0]};Secure,path=/;domain=.5paisa.com;`; // cookies
          document.cookie = `${result[1]};Secure,path=/;domain=.5paisa.com;`; // jwtToken
          localStorage.setItem(
            this.constantService.localStorageElement.subSource,
            result[2]?.toUpperCase() ||
            localStorage.getItem(this.constantService.localStorageElement.subSource) ||
              ''
          );
          const clientCode = this.encryptionService.decryptUsingAES256(result[result.length-1]);
          localStorage.setItem(this.constantService.localStorageElement.clientCode,clientCode || '')      
        };
      } catch (e) {
        console.error('Error setting up reKyc_Func:', e);
      }
    }

    JWTToken(){
      const appSource = 'CLIENTWEB';
      //clientCode + appSource + ip + time
      const checkSum =  this.userSessionService.getUserSessionData().clientCode +  appSource + this.userSessionService.getUserSessionData().ip +this.utilService.checkSumDate;

      const jwtTokenReq : JWTTokenReq = {
        head: {
          IPAddress: this.userSessionService.getUserSessionData().ip,
          AppSource: appSource,
          ChecksumValue: this.utilService.GenerateCheckSum(checkSum, appSource)
      },
      body: {
          clientcode: this.userSessionService.getUserSessionData().clientCode
      }
      }
      this.tokenService.JWTToken(jwtTokenReq).subscribe({next:(response)=>{
        console.log(response);
        localStorage.setItem(SessionStorage.authorization_Modi, 'Bearer ' + response.body.Token);
       
        this.sessionStorageService.setItem(
            SessionStorage.authorization_Modi,
            'Bearer ' + response.body.Token
        );
      },error : (err)=>{

      }})
    }
}